<template>
  <div :style="'height:'+ (store.state.windowHeight - 140)  +'px'" @click="handlePageClick">
    <el-form :model="obj">
      <div class='columns'>
        <div class="column-4" style="width:400px"> 
          <el-form-item label="多头合约">       
              <el-input
              v-model="obj.searchValue"
              placeholder="名称/代码 搜索合约"
              @input="handleInput"
              style="width: 250px"
              clearable
              >
              <template #prefix>
                <el-icon class="el-input__icon"><search /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <div v-for="data in obj.hedgeList" :key="data">
            <el-form-item label="">
              <el-input v-model="data.name" :disabled="true" style="width:150px;color:red"/>
              <el-input-number v-model="data.quantity" :min="1" :max="100" :precision="0" style="width:120px"/>
              <el-button type="danger" @click="del(data)">删除</el-button>
            </el-form-item>
          </div>
        </div> 
        <div class="column-4" style="width:400px">
          <el-form-item label="空头合约">
            <el-input
              v-model="obj.searchValue2"
              placeholder="名称/代码 搜索合约"
              @input="handleInput2"
              style="width: 250px"
              clearable
              >
              <template #prefix>
                <el-icon class="el-input__icon"><search /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <div v-for="data in obj.hedgeList2" :key="data">
            <el-form-item label="">
              <el-input v-model="data.name" :disabled="true" style="width:150px;color:green"/>
              <el-input-number v-model="data.quantity" :min="1" :max="100" :precision="0" style="width:120px"/>
              <el-button type="danger" @click="del2(data)">删除</el-button>
            </el-form-item>
          </div>
        </div> 
      </div>     
      <div class='columns'>
        <div class="column-2" style="width:750px"> 
          <el-date-picker
            v-model="obj.date"
            type="daterange"
            range-separator=" ~ "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled-date="disabledDate"
            @change="handleDateChange"
            format="YYYY/MM/DD"
            value-format="YYYY-MM-DD"
            style="width:100%"
          />     
        </div>
      </div>
      <div class='columns'>
        <div class="column-2" style="width:750px"> 
          <el-form-item label="">
            <el-button type="primary" @click="submit" style="width:100%">执行</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div id="chart" style="width: 100%" :style="'height:'+ (this.$store.state.windowHeight /2) +'px'" ref="chartDomRef" ></div>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{data['name']}} {{data['symbol']}} {{data['exchange']}}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
    <div style="width: 250px; max-height: 420px;" class='search-ul2'>
      <div v-for="data in obj.filteredList2" :key="data" class="search-li2" @click="handleClick2(data)">
        {{data['name']}} {{data['symbol']}} {{data['exchange']}}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { http } from "../util/http";
import { ElMessage } from 'element-plus'
import { setCharts } from '../module/line'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const chartDomRef = ref()
    const obj = reactive({
      searchList: [],
      searchList2: [],
      filteredList: [],
      filteredList2: [],
      searchValue: '',
      searchSymbol:'',
      searchExchange:'',
      searchValue2: '',
      searchSymbol2:'',
      searchExchange2:'',
      hedgeList: [],
      hedgeList2: [],
      date: null,
      legendData: [],
      Xdata: [],
      seriesData: [],
      seriesList: [],
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '9') 
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.hedgeData === ''){
        // 无缓存，从后台请求数据
        renderSelect()
      } else {
        // 有缓存，设定页面状态
        getStore()
        // 渲染图表
        var myChart = renderChart()
        // 保存缓存(否则chart无法自适应窗口)
        setStore(myChart)
      }
    }

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "main_all")
      http({
        url: `/market`,
        method: 'post',
        data: formData
      }).then((res) => {
        obj.searchList = res.data.data
        obj.searchList2 = res.data.data
      })
    }

    // 搜索框输入事件(多头)
    const handleInput = () => {
      obj.filteredList2 = []
      obj.searchValue2 = ''
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
      item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框输入事件(空头)
    const handleInput2 = () => {
      obj.filteredList = []
      obj.searchValue = ''
      if (obj.searchValue2.trim() === '') {
        obj.filteredList2 = []
        return
      }
      obj.filteredList2 = obj.searchList2.filter(item => item['name'].toUpperCase().includes(obj.searchValue2.trim().toUpperCase()) ||
      item['symbol'].toUpperCase().includes(obj.searchValue2.trim().toUpperCase()))
    }

    // 搜索结果点击事件(多头)
    const handleClick = (data) => {
      obj.searchValue = ''
      obj.filteredList = []

      let msg = ''
      obj.hedgeList.forEach((item) => {
        if (item.name === data['name']){
          msg = '多头合约中已经存在'
        }
        if (obj.hedgeList.length === 4){
          msg = '多头最多选择4个合约'
        }
      })
      obj.hedgeList2.forEach((item) => {
        if (item.name === data['name']){
          msg = '空头合约中已经存在'
        }
      })

      if (msg !== '') {
        ElMessage.error(msg)
        obj.searchValue = ''
        return
      }
      
      data['quantity'] = 1
      obj.hedgeList.push(data)
     
    }
    
    // 搜索结果点击事件(空头)
    const handleClick2 = (data) => {
      obj.searchValue2 = ''
      obj.filteredList2 = []

      let msg = ''
      obj.hedgeList2.forEach((item) => {
        if (item.name === data['name']){
          msg = '空头合约中已经存在'
        }
        if (obj.hedgeList2.length === 4){
          msg = '空头最多选择4个合约'
        }
      })
      obj.hedgeList.forEach((item) => {
        if (item.name === data['name']){
          msg = '多头合约中已经存在'
        }
      })

      if (msg !== '') {
        ElMessage.error(msg)
        obj.searchValue2 = ''
        return
      }
      
      data['quantity'] = 1
      obj.hedgeList2.push(data)
     
    }

    // 删除合约(多头)
    const del = (data) => {
      obj.hedgeList.forEach((item) => {
        if (item.name === data.name){
          console.log(item.name)
          obj.hedgeList.splice(obj.hedgeList.indexOf(item),1)
        }
      })
    }

    // 删除合约(空头)
    const del2 = (data) => {
      obj.hedgeList2.forEach((item) => {
        if (item.name === data.name){
          obj.hedgeList2.splice(obj.hedgeList2.indexOf(item),1)
        }
      })
    }

    // 页面空白点击事件
    const handlePageClick = () => {
      obj.filteredList = []
      obj.filteredList2 = []
      obj.searchValue = ''
      obj.searchValue2 = ''
    }

    // 日期picker不能选择今天之后的日子
    const disabledDate = (time) => {
      return time.getTime() > Date.now()
    }

    // 表单check
    const formCheck = () => {
      if (obj.hedgeList.length === 0 || obj.hedgeList2.length === 0){
        ElMessage.error('请添加多空合约')
        return false
      }
      console.log(obj.date)
      if (obj.date === null){
        ElMessage.error('请选择时间段')
        return false
      }
      return true
    } 

    // 提交处理
    const submit = () => {
      console.log(obj.hedgeList)
      console.log(obj.hedgeList2)

      let name_long = obj.hedgeList.map(item => item.name)
      let name_short = obj.hedgeList2.map(item => item.name)
      let quantity_long = obj.hedgeList.map(item => item.quantity)
      let quantity_short = obj.hedgeList2.map(item => item.quantity)

      // console.log(name_long)
      // console.log(name_short)
      // console.log(quantity_long)
      // console.log(quantity_short)

      if (!formCheck()){
        return
      }
      let formData = new FormData()
      formData.append("name_long", name_long)
      formData.append("name_short", name_short)
      formData.append("quantity_long", quantity_long)
      formData.append("quantity_short", quantity_short)
      formData.append("date", obj.date)
      http({
        url: `/hedge`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res)
        processData(res)
        var myChart = renderChart()
        setStore(myChart)
      })
    }
    
    // 后台获取数据
    const processData = (res) => {
      obj.legendData = res.data.data[0]
      obj.Xdata = res.data.data[1]
      obj.seriesData = res.data.data[2]
    }
    
    // 加工处理数据
    const renderChart = () => {
      obj.seriesList = []
      for (var j in obj.legendData){
          // 设置坐标数据
          if (j == obj.legendData.length-1){
            obj.seriesList.push({'name': obj.legendData[j], 
              'type': 'line',
              'data': obj.seriesData[j],
              // 'smooth': true,
              'showSymbol': true,
              'label' : {'show': true},
              itemStyle: {
                normal: {
                    color: 'black', //改变折线点的颜色
                    lineStyle: {
                        color: 'black' //改变折线颜色
                    }
                }
              }
            })
          } else {
            obj.seriesList.push({'name': obj.legendData[j], 
              'type': 'bar',
              'data': obj.seriesData[j],
              // 'smooth': true,
              'showSymbol': true,
              'label' : {'show': false},
              // 'areaStyle': {},
              'tooltip': {
                'trigger': 'axis',
              },
              })
          }  
      }
      // console.log(obj.legendData)
      // console.log(obj.Xdata)
      // console.log(obj.seriesList)
      var myChart = setCharts(chartDomRef.value, '', obj.legendData, obj.Xdata, obj.seriesList)
      return myChart
    }

    // 保存至store
    const setStore = (myChart) => {
      store.commit('setMyChart', myChart)
      var storeObj = {'searchList':obj.searchList,
                      'searchList2': obj.searchList2,
                      'filteredList': obj.filteredList,
                      'filteredList2': obj.filteredList2,
                      'searchValue': obj.searchValue,
                      'searchSymbol': obj.searchSymbol,
                      'searchExchange': obj.searchExchange,
                      'searchValue2': obj.searchValue2,
                      'searchSymbol2': obj.searchSymbol2,
                      'searchExchange2': obj.searchExchange2,
                      'hedgeList': obj.hedgeList,
                      'hedgeList2': obj.hedgeList2,
                      'date': obj.date,
                      'legendData': obj.legendData,
                      'Xdata': obj.Xdata,
                      'seriesData': obj.seriesData,
                      'seriesList': obj.seriesList,
                      }
      store.commit('setHedgeData', storeObj) // 缓存数据
    }

     // 获取Store
    const getStore = () => {
      obj.searchList = store.state.hedgeData.searchList
      obj.searchList2 = store.state.hedgeData.searchList2
      obj.filteredList = store.state.hedgeData.filteredList
      obj.filteredList2 = store.state.hedgeData.filteredList2
      obj.searchValue = store.state.hedgeData.searchValue
      obj.searchSymbol = store.state.hedgeData.searchSymbol
      obj.searchExchange = store.state.hedgeData.searchExchange
      obj.searchValue2 = store.state.hedgeData.searchValue2
      obj.searchSymbol2 = store.state.hedgeData.searchSymbol2
      obj.searchExchange2 = store.state.hedgeData.searchExchange2
      obj.hedgeList = store.state.hedgeData.hedgeList
      obj.hedgeList2 = store.state.hedgeData.hedgeList2
      obj.date = store.state.hedgeData.date
      obj.legendData = store.state.hedgeData.legendData
      obj.Xdata = store.state.hedgeData.Xdata
      obj.seriesData = store.state.hedgeData.seriesData
      obj.seriesList = store.state.hedgeData.seriesList
    }

    return {
      obj,
      store,
      chartDomRef,
      handleInput,
      handleInput2,
      handleClick,
      handleClick2,
      del,
      del2,
      handlePageClick,
      disabledDate,
      submit
    }
  }
}
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 150px;
  top: 100px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}
.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}
.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
.search-ul2 {
  position: absolute;
  left: 550px;
  top: 100px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}
.search-li2 {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}
.search-li2:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
